export const translation = {
  projectName: "Wilms - Rechtsanwälte",

  home: {
    hero: {
      subtitle: ["Herzlich", "Willkommen"],
      cta: "Mehr erfahren",
    },
    intro: {
      headlinePrefix: "Über unsere",
      headline: " Kanzlei",
      subline: "Hintergrundinfos",
      textPrefix: "Herzlich willkommen auf den Internetseiten ",
      text: "der WILMS Rechtsanwälte. Seit über 25 Jahren unterstützen wir in unserer multidisziplinären Kanzlei kleine und mittelständische Unternehmen und Unternehmer:innen, Freiberufler:innen und Verbraucher:innen bei der Wahrung und Wahrnehmung ihrer Rechte. Wir beraten, um Lösungen zu finden und Streit vorzubeugen, und vertreten unsere Mandant:innen, wenn es bereits zum Streit gekommen ist.",
    },
    fachgebiete: {
      headlinePrefix: "Unsere",
      headline: " Fachgebiete",
      subline: "Übersicht",
    },
    team: {
      headlinePrefix: "Unser",
      headline: " Team",
      subline: "Anwält:innen",
    },
    checklist: {
      headlinePrefix: "Checkliste für Ihre",
      headline: " Kontaktaufnahme",
      subline: "Übersicht",
      items: [
        {
          highlight: "Terminvereinbarung",
          text: "Bitte melden Sie sich telefonisch oder per E-Mail bei uns, um einen Gesprächstermin zu vereinbaren. Nennen Sie dabei kurz Ihr Anliegen, damit wir es intern passend zuordnen können.",
        },
        {
          highlight: "Fristen im Blick behalten",
          text: "Rechtliche Angelegenheiten unterliegen oft engen Fristen. Warten Sie daher nicht zu lange mit der Kontaktaufnahme, insbesondere wenn Sie bereits Schreiben von Behörden, Gerichten oder der Gegenseite erhalten haben.",
        },
        {
          highlight: "Kurze Sachverhaltszusammenfassung",
          text: "Überlegen Sie im Vorfeld: Was genau ist passiert? Wann ist es passiert? Wer war beteiligt? Eine stichpunktartige Übersicht hilft dabei, im Gespräch keine wesentlichen Details zu vergessen.",
        },
        {
          highlight: "Relevante Unterlagen",
          text: "Bitte bringen Sie alle Dokumente mit, die mit Ihrem Anliegen in Zusammenhang stehen (z. B. Verträge, Schriftwechsel, Fotos, Bescheide oder Belege). Wenn möglich, bewahren Sie auch Umschläge auf, da Versand- oder Zustelldaten wichtig sein können.",
        },
        {
          highlight: "Angaben zu Zeug:innen",
          text: "Falls andere Personen den Sachverhalt bezeugen können, halten Sie bitte deren Namen und Kontaktdaten bereit.",
        },
        {
          highlight: "Zielvorstellung",
          text: "Machen Sie sich gerne vorab Gedanken darüber, was Sie sich von unserer Unterstützung erhoffen: eine außergerichtliche Einigung, eine gerichtliche Klärung oder zunächst eine rechtliche Einschätzung.",
        },
        {
          highlight: "Persönliche Daten",
          text: "Bitte halten Sie Ihre Kontaktdaten sowie, sofern bekannt, Informationen zur Gegenseite bereit (z. B. Name, Adresse, ggf. Ansprechpartner:in bei Unternehmen).",
        },
        {
          highlight: "Rechtsschutzversicherung",
          text: "Falls Sie rechtsschutzversichert sind, teilen Sie uns bitte den Namen Ihrer Versicherung und, sofern vorhanden, Ihre Versicherungs- oder Schadennummer mit. Weitere Fragen zur Deckungsanfrage können anschließend gemeinsam geklärt werden.",
        },
        {
          highlight: "Ausweisdokument",
          text: "Für eine eindeutige Identifikation benötigen wir in der Regel einen gültigen Personalausweis oder Reisepass. Dies ist insbesondere wichtig, wenn eine Vollmacht erteilt oder ein Verfahren eingeleitet werden soll.",
        },
      ],
    },
  },

  contact: {
    hero: {
      subtitle: [""],
      title: ["Kontakt"],
    },
    intro: {
      headlinePrefix: "Wilms",
      headline: " Rechtsanwälte",
      subline: "Anwaltskanzlei",
    },
    openHoursText: "Sie erreichen uns zu folgenden Bürozeiten:",
    openHours: [
      "Montag – Donnerstag 9.00 – 17.00 Uhr",
      "Freitag 9.00 – 15.00 Uhr",
    ],
    section: {
      headline: "Kontaktformular",
      cta: "Senden",
      hint: "Sämtliche Anfragen per E-Mail oder Kontaktformular werden nur beantwortet, sofern alle Pflichtangaben vollständig ausgefüllt wurden.",
      privacyHintPrefix:
        "Informationen zur Verarbeitung Ihrer personenbezogenen Daten finden Sie in unserer ",
      privacyHintLinkLabel: "Datenschutzerklärung",
      privacyHintLink: "/datenschutzerklaerung",
      privacyHintSuffix: ".",
      success: "Ihre Nachricht wurde erfolgreich versendet.",
      error: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    },
  },

  areas: {
    VERTRAGSRECHT: "Vertragsrecht",
    VERKEHRSRECHT: "Verkehrsrecht",
    MEDIZINRECHT: "Medizinrecht",
    ARBEITSRECHT: "Arbeitsrecht",
    FAMILIENRECHT: "Familienrecht",
    ITUNDDATENRECHT: "Datenschutzrecht",
    MIETUNDWOHNUNGSEIGENTUMSRECHT: "Miet- und Wohnungseigentumsrecht",
    GEWERBLICHERRECHTSSCHUTZUNDURHEBERRECHT:
      "Gewerblicher Rechtsschutz und Urheberrecht",
    ERBRECHT: "Erbrecht",
    TRANSPORTRECHT: "Transportrecht",
    HANDELUNDGESELLSCHAFTSRECHT: "Handels- und Gesellschaftsrecht",
    ALLGEMEINESZIVILRECHT: "Allgemeines Zivilrecht",
    LLMINFORMATIONSRECHT: "LL.M. Informationsrecht",
  },

  areasSlider: {
    itemLabel: "Themengebiet",
  },

  lawyersView: {
    hero: {
      subtitle: ["Übersicht"],
      title: ["Rechtsanwälte"],
    },
    contact: {
      title: "Kontakt",
      form: {
        label: "Kontaktformular",
        link: "/kontakt",
      },
    },
    vita: {
      title: "Vita",
    },
    memberships: {
      title: "Mitgliedschaften",
    },
    areas: {
      prefix: "Seine",
      text: "Fachgebiete",
      subline: "Übersicht",
    },
  },

  lawyers: {
    hero: {
      subtitle: ["Übersicht"],
      title: ["Rechtsanwälte"],
    },
    intro: {
      headlinePrefix: "Über unsere",
      headline: " Rechtsanwälte",
      subline: "Hintergrundinfos",
      text: "Ihre Expert:innen für jedes Rechtsgebiet. Unser Team aus erfahrenen Rechtsanwält:innen steht für Kompetenz, Engagement und klare Mandantenorientierung. Mit exzellenter Fachkenntnis setzt sich unser Team für Ihre rechtlichen Anliegen ein.",
    },
    headline: "Unsere Anwält:innen",
    areaPrefix: "Fachanwalt für ",
    contactData: "Kontaktdaten",
    showAllCTA: "Alle Anwält:innen",
  },

  subjectAreas: {
    hero: {
      subtitle: [
        "Seit über 25 Jahren sind wir in diesen Rechtsbereichen für Sie tätig.",
      ],
      title: ["Fachgebiete"],
    },
    intro: {
      headlinePrefix: "Unsere",
      headline: " Fachgebiete",
      subline: "Rechtssicherheit in allen Lebenslagen",
      text: "Wilms Rechtsanwälte – Ihre Expert:innen für umfassende rechtliche Beratung und Vertretung. Gemeinsam schaffen wir Klarheit, schützen Ihre Interessen und finden passende Lösungen für Ihre rechtlichen Anliegen.",
    },
    headline: "Unsere Anwält:innen",
    areaPrefix: "Fachanwalt für ",
    showAllCTA: "Alle Anwält:innen",
  },

  subjectAreaView: {
    hero: {
      subtitle: ["Fachgebiet"],
    },
    bullets: {
      title: "Stichpunkte",
    },
    more: {
      title: "Weitere Informationen",
    },
    lawyersList: {
      headlinePrefix: "Rechtsanwälte mit diesem",
      headline: " Fachgebiet",
      subline: "Übersicht",
    },
    areaOverview: {
      headlinePrefix: "Unsere",
      headline: " Fachgebiete",
      subline: "Übersicht",
    },
  },

  kanzlei: {
    hero: {
      subtitle: ["Übersicht"],
      title: ["Kanzlei"],
    },
    intro: {
      headlinePrefix: "Über unsere",
      headline: " Kanzlei",
      subline: "Hintergrundinfos",
      text: "Seit über 25 Jahren steht Wilms Rechtsanwälte in Berlin-Tempelhof für fundierte Expertise, individuelle Lösungen und eine vertrauensvolle Zusammenarbeit. In zwei alten Gutshäusern aus dem 19. Jahrhundert verbinden sich Tradition und Moderne. Lernen Sie unsere Kanzlei und unser Team kennen.",
    },
  },

  blog: {
    hero: {
      subtitle: [
        "Seit über 25 Jahren sind wir in diesen Rechtsbereichen für Sie tätig.",
      ],
      title: ["Blog"],
    },
    intro: {
      headlinePrefix: "Unsere",
      headline: " Blog",
      subline: "Alles zum Thema Recht",
      text: [
        "Klar. Verständlich. Auf den Punkt.",
        "Rechtsthemen, die bewegen, von Experten erklärt.",
        "Ob aktuelle Urteile, Gesetzesänderungen oder praxisnahe Tipps: In unserem Kanzlei-Blog informieren wir Sie fundiert und verständlich über relevante Entwicklungen mit klarem Fokus auf das Wesentliche.",
        "Wir möchten juristische Themen transparent und greifbar machen. Entdecken Sie Neuigkeiten aus verschiedenen Rechtsbereichen und aus dem Raum Berlin und verschaffen Sie sich frühzeitig einen Überblick über mögliche Konsequenzen.",
        "Damit Sie rechtlich immer auf dem Laufenden bleiben.",
      ],
    },
  },

  career: {
    hero: {
      subtitle: "Karriere",
      title: ["Viele Menschen", "mit einem Ziel"],
      subline: "Werden Sie Teil von Wilms Rechtsanwälte",
    },
    boxes: [
      {
        title: "Team",
        text: "In unserer Kanzlei ist Zusammenhalt von großer Bedeutung. Gemeinsam arbeiten wir daran, unsere Ziele zu erreichen und unsere Mandant:innen bestmöglich zu unterstützen. Durch unsere enge Zusammenarbeit schaffen wir eine starke Grundlage für unseren gemeinsamen Erfolg.",
      },
      {
        title: "AUSGLEICH",
        text: "Wir legen Wert auf eine gute Balance zwischen Beruf und Privatleben. Unsere Mitarbeitenden haben individuelle Bedürfnisse und Lebensumstände, die wir respektieren und unterstützen möchten. Denn nur mit einem gesunden Ausgleich kann berufliches Potenzial langfristig voll entfaltet werden.",
      },
      {
        title: "Austausch",
        text: "Wir möchten unsere Mitarbeitenden dabei unterstützen, sich fachlich und persönlich weiterzuentwickeln. Unterschiedliche Perspektiven, Erfahrungen und Ideen helfen uns dabei, Lösungen zu finden und eine vertrauensvolle Verbindung zu unseren Mandant:innen aufzubauen.",
      },
    ],
    reasons: {
      headline: "9 Gründe, Teammitglied zu werden",
      items: [
        {
          title: "Modernes Arbeitsumfeld",
          text: "Bei uns erwartet Sie ein modernes Arbeitsumfeld, das mit zeitgemäßen Technologien und digitalen Arbeitsmitteln ausgestattet ist.",
        },
        {
          title: "Effiziente Arbeitsprozesse",
          text: "Wir setzen auf digitale Tools und klare Abläufe, um unsere Arbeitsprozesse effizient, strukturiert und produktiv zu gestalten.",
        },
        {
          title: "Flexibilität und Eigenverantwortung",
          text: "Wir bieten Ihnen flexible Arbeitszeiten und die Möglichkeit, eigenverantwortlich zu arbeiten. Sie können Ihre Aufgaben aktiv mitgestalten und Ihre Stärken einbringen.",
        },
        {
          title: "Raum für Ideen",
          text: "Bei uns sind neue Ideen willkommen. Wir ermutigen Sie, eigene Vorschläge einzubringen und lösungsorientiert mitzudenken.",
        },
        {
          title: "Begeisterung für Technologie",
          text: "Wir arbeiten gerne mit modernen digitalen Lösungen und entwickeln unsere Arbeitsweise kontinuierlich weiter. Sie haben die Möglichkeit, mit zeitgemäßen Tools zu arbeiten und Ihre Fähigkeiten auszubauen.",
        },
        {
          title: "Angenehme Arbeitsatmosphäre",
          text: "Unser Arbeitsplatz verbindet moderne Ausstattung mit einer angenehmen Atmosphäre. Wir möchten, dass Sie sich bei uns wohlfühlen und konzentriert arbeiten können.",
        },
        {
          title: "Langfristige Perspektive",
          text: "Durch unsere gewachsene Kanzleistruktur und unsere Offenheit für Weiterentwicklung bieten wir Ihnen langfristige Perspektiven in einem stabilen beruflichen Umfeld.",
        },
        {
          title: "Teamgeist und Zusammenarbeit",
          text: "Bei uns steht Teamgeist im Vordergrund. Wir legen Wert auf eine respektvolle Zusammenarbeit, kurze Wege und eine Arbeitsatmosphäre, in der wir uns gegenseitig unterstützen.",
        },
        {
          title: "Weiterbildung und Entwicklung",
          text: "Wir unterstützen Ihre persönliche und fachliche Weiterentwicklung und bieten Ihnen Möglichkeiten, Ihre Kenntnisse kontinuierlich auszubauen.",
        },
      ],
    },
    quote: {
      text: "„Es hat keinen Sinn zu tun, was einem gefällt - man muss Gefallen finden an dem, was man tut.”",
    },
    contact: {
      headline: "Ihre Ansprechpartner:innen",
      people: [
        {
          name: "Friedrich Schulze",
          title: "Rechtsanwalt",
          mail: "karriere@wilms.eu",
        },
        {
          name: "Kathrin Freist",
          title: "Rechtsanwältin",
          subtitle: "LL.M. Informationsrecht",
          mail: "karriere@wilms.eu",
        },
      ],
    },
    openPositions: {
      headline: "Unsere offenen Stellen",
      tasks: "Ihre Aufgaben bei uns:",
      expectations: "Uns ist wichtig:",
      offerings: "Es erwartet Sie:",
      form: {
        entryDate: "Wunsch-Eintrittsdatum",
        salaryExpectation: "Gehaltsvorstellung",
        dragAndDropTitle: "Drag & Drop",
        dragAndDropHint: [
          "Eigene Dokumente hier hochladen",
          "(Lebenslauf, Zeugnisse oder ähnliche Unterlagen)",
        ],
        maxFileSizeExceededToast:
          "Ihre Datei überschreitet die zulässige Größe von 50 MB.",
        cta: "Bewerbung senden",
        error: "Beim Versand Ihrer Bewerbung ist ein Fehler aufgetreten.",
        success:
          "Wir haben Ihre Bewerbung erhalten und melden uns schnellstmöglich.",
      },
      items: [
        {
          title: "RECHTSANWALTSFACHANGESTELLTE:R (M/W/D)",
          tasks:
            "Sie erledigen die Korrespondenz mit Gerichten, Gegner:innen und Mandant:innen und sind für diese häufig erste Ansprechperson. Zudem übernehmen Sie organisatorische Aufgaben wie die Bearbeitung der Eingangspost, das Fristenmanagement und die Koordinierung von Terminen.",
          expectations:
            "Wir geben Aufgaben und Richtung vor, legen aber großen Wert auf eigenständiges Arbeiten. Sie erhalten Raum, eigene Ideen einzubringen und Verantwortung zu übernehmen. Sorgfältiges Arbeiten ist in unserem Beruf unverzichtbar – ebenso wie ein respektvoller Umgang miteinander.",
          offerings:
            "Unser Team verbindet Erfahrung, Engagement und Freude an der gemeinsamen Arbeit. Über viele Jahre ist ein gewachsener Mandantenstamm entstanden, der uns zuverlässig vor abwechslungsreiche Aufgaben stellt. Das, was wir tun, machen wir gern. Wenn Sie Teil unseres Teams werden möchten, freuen wir uns auf Ihre Bewerbung.",
        },
      ],
      success: {
        form: "Ihre Bewerbung wurde erfolgreich verschickt. Wir melden uns schnellstmöglich bei Ihnen.",
      },
      error: {
        form: "Aufgrund eines technischen Fehlers konnte Ihre Bewerbung nicht verschickt werden.",
      },
    },
  },

  header: {
    navigation: {
      default: [
        {
          name: "Start",
          link: "/",
        },
        {
          name: "Fachgebiete",
          link: "/fachgebiete",
        },
        {
          name: "Rechtsanwälte",
          link: "/rechtsanwaelte",
        },
        {
          name: "Kanzlei",
          link: "/kanzlei",
        },
        {
          name: "Kontakt",
          link: "/kontakt",
        },
        {
          name: "Karriere",
          link: "/karriere",
        },
        // {
        //   name: "Blog",
        //   link: "/blog",
        // },
      ],
      member: [
        {
          name: "Projekte",
          link: "/dashboard/files",
        },
        {
          name: "Zeiterfassung",
          link: "/dashboard/timetracking",
          requiredPermission: "settingsTimetacker",
        },
        {
          name: "Einstellungen",
          link: "/dashboard/settings",
          requiredPermission: "settingsAccess",
        },
      ],
      isLoggedIn: {
        name: "Abmelden",
      },
    },
  },

  dashboard: {
    title: "Dashboard",
  },

  login: {
    headline: "Anmelden",
    cta: "Anmelden",
    error: "Anmeldung fehlgeschlagen. Falsche E-Mail oder Passwort.",
  },

  settings: {
    title: "Einstellungen",
    memberManagement: {
      title: "Mitarbeiter",
      upsert: {
        titleCreate: "Mitarbeiter hinzufügen",
        titleUpdate: "Mitarbeiter bearbeiten",
        cta: "Mitarbeiter hinzufügen",
        success: "Mitarbeiter wurde erfolgreich gespeichert",
        error: {
          upsert: "Mitarbeiter konnte nicht gespeichert werden",
          remove: "Mitarbeiter konnte nicht gelöscht werden",
          loading: "Mitarbeiter konnten nicht geladen werden",
        },
        edit: "Mitarbeiter bearbeiten",
        remove: {
          title: "Mitarbeiter löschen",
          hint: "Sind Sie sicher, dass Sie diesen Mitarbeiter löschen möchten?",
          error: "Mitarbeiter konnte nicht gelöscht werden",
        },
      },
    },
  },

  footer: {
    links: "Links",
    legalLinks: [
      { name: "Impressum", link: "/impressum" },
      { name: "Datenschutz", link: "/datenschutzerklaerung" },
    ],
  },

  generic: {
    company: {
      name: "Wilms Rechtsanwälte",
      street: "Alt-Tempelhof 37/41",
      city: "12103 Berlin",
      phone: "+49 30 75 79 64 0",
      fax: "+49 30 75 79 64 8",
    },
    settings: "Einstellungen",
    hourPrefix: "Stunden: ",
    hourSuffix: " Stunden",
    squareMeterSuffix: " m²",
    equals: " = ",
    timestampPrefix: "Erstellt am: ",
    phoneShortPrefix: "T ",
    faxShortPrefix: "T ",
    phonePrefix: "Telefon: ",
    mailPrefix: "E-Mail: ",
    websitePrefix: "Webseite: ",
    employeeSuffix: " Mitarbeiter",
    subject: "Betreff",
    text: "Nachricht",
    salutation: "Anrede",
    name: "Name",
    firstname: "Vorname",
    lastname: "Nachname",
    birthday: "Geburtsdatum",
    personType: "Art",
    personTypePlaceholder: "Beirat, Geschäftsführer, ...",
    street: "Straße, Hausnummer",
    companyName: "Firmenname",
    club: "Verein (optional)",
    city: "PLZ, Ort",
    mail: "E-Mail-Adresse",
    identifier: "E-Mail-Adresse",
    message: "Ihre Anfrage...",
    phone: "Telefonnummer",
    password: "Passwort",
    passwordRepeat: "Passwort wiederholen",
    createdOn: "Erstellt am",
    confirm: "Bestätigen",
    cancel: "Abbrechen",
    close: "Schließen",
    send: "Senden",
    error:
      "Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es später erneut.",
    acceptAGB: "Ich akzeptiere die AGB",
    percent: " %",
    kilometerSuffix: " km",
    upload: "Hochladen",
    login: "Anmelden",
    logout: "Abmelden",
    export: "Export",
    import: "Import",
    save: "Speichern",
  },

  UI: {
    removeConfirmation: {
      title: "Bestätigung",
      text: (itemName: string) => `Möchten Sie "${itemName}" wirklich löschen?`,
    },
    copyConfirmation: {
      title: "Kopieren",
      text: (itemName: string) => `${itemName}-Kopie umbenennen zu:`,
      initNameSuffix: "-Kopie",
    },
    customerSelector: {
      label: "Kundenauswahl",
    },
    projectSelector: {
      label: "Projekt wählen",
    },
    projectAreaSelector: {
      label: "Projektbereich wählen",
    },
    contactPersonManager: {
      title: "Kontaktpersonen",
      addTitle: "Kontaktperson hinzufügen",
      updateTitle: "Kontaktperson bearbeiten",
      empty: "Keine Kontaktpersonen vorhanden",
      add: "hinzufügen",
    },
    organizationUnitManager: {
      title: "Organisationseinheiten",
      addTitle: "Organisationseinheit hinzufügen",
      employeeAmountSuffixShort: " MA",
      employeeAmountSuffix: " Mitarbeiter",
      updateTitle: "Organisationseinheit bearbeiten",
      empty: "Keine Organisationseinheiten vorhanden",
      add: "hinzufügen",
    },
    simpleList: {
      search: "Suche",
      resultAmountSuffixPlural: " Ergebnisse",
      resultAmountSuffixSingular: " Ergebnis",
      noData: "Keine Daten vorhanden",
    },
    multiList: {
      search: "Suche",
      resultAmountSuffix: " Ergebnisse",
      noData: "Keine Daten vorhanden",
      cta: "Ausführen",
      cancelCTA: "Abbrechen",
      option: {
        EXPORT: "Export",
        PROCESS: "Verarbeiten",
        STOP: "Stoppen",
      },
      export: {
        title: "Export",
        identifier: "Kennung",
      },
      error: "Aktion konnte nicht ausgeführt werden",
    },
    csvImport: {
      title: "Import",
      startCTA: "Import starten",
      loading: "Daten werden imporiert...",
      error: "Der Import ist fehlgeschlagen.",
    },
    dropdown: {
      emptySelection: "Bitte wählen",
      search: "Suche",
    },
    selectableTagList: {
      showMore: "Mehr anzeigen",
      showLess: "Weniger",
    },
    textarea: {
      max: {
        prefix: "maximal ",
        suffix: " Zeichen",
      },
    },
    dnd: {
      text: "Bewerbung anhängen",
      hint: "(Erlaubt ist eine PDF-Datei bis zu 25 MB)",
      selectedPrefix: "Gewählte PDF: ",
      error: {
        size: "Maximale Dateigröße überschritten",
      },
    },
  },

  resetPassword: {
    passwordsDontMatch: "Passwörter stimmen nicht überein",
    passwordReset: "Passwort wurde erfolgreich geändert",
    save: "Ändern",
    password: "Passwort",
    passwordRepeat: "Passwort wiederholen",
    title: "Passwort ändern",
  },
};

export const langKey = "DE";
